import { ISimpleCertificate } from '../services/certificate.api-service';

export class SimpleCertificate {
    id: string;
    name: string;
    filename?: string;
    selected?: boolean; // Frontend property

    constructor(query: ISimpleCertificate) {
        this.id = query.id;
        this.name = query.name;
        if (query.filename) {
            this.filename = query.filename;
        }
    }
}
